export default () => {
  if (process.env.NODE_ENV === 'production') {
    window.addEventListener('beforeunload', function (e) {
      e.preventDefault();
      e.returnValue = '';
    });
  }
}